// extracted by mini-css-extract-plugin
export var closeButton = "_ou-2";
export var closeButtonIcon = "_ou-3";
export var lightboxContent = "_ou-1";
export var lightboxOverlay = "_ou-0";